import {api} from "../../services";
import Swal from "sweetalert2";

const tasks = {
    state: {
        pagination: [],
        done: [],
        data: [],
        task: {},
        calendar: []
    },
    getters: {
        getTaskObject: (state) => (key, value) => {
            const object = state.data.find(item => {
                return item[`${key}`] === value;
            });
            return object === undefined ? {} : object;
        },
        getTasksArray: (state) => (key, value) => {
            if (state.data !== undefined) {
                return state.data.filter(item => {
                    return item[`${key}`] === value;
                });
            }
            return [];
        },
    },
    mutations: {
        SET_TASKS(state, payload) {
            state.pagination = payload
        },
        SET_TASKS_DONE(state, payload) {
            state.done = payload
        },
        SET_TASKS_DATA(state, payload) {
            payload.forEach(p => {
                const exist = state.data.find(e => {
                    return e.id === p.id;
                });
                if (!exist) {
                    state.data.push(p);
                }
            });
        },
        SET_TASK(state, payload) {
            state.task = payload
        },
        SET_CALENDAR(state, payload) {
            state.calendar = payload
        },
    },
    actions: {
        getTasks(context, payload) {
            api.get('/tasks', {
                params: payload
            }).then(response => {
                context.commit("SET_TASKS", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        getTasksDone(context, payload) {
            api.get('/tasks', {
                params: payload
            }).then(response => {
                context.commit("SET_TASKS_DONE", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        getTasksData(context, payload) {
            let ids = [];
            payload.forEach(p => {
                const item = context.state.data.find(i => {
                    return p === i.id
                });
                if (item === undefined) {
                    ids.push(p);
                }
            });
            if (ids.length > 0) {
                api.post(`/tasks`, {ids}).then(response => {
                    context.commit("SET_TASKS_DATA", response.data);
                }).catch(error => {
                    if (error.response.status === 401) {
                        this.dispatch('logoutUser');
                    } else {
                        Swal.fire(
                          `${ context.rootGetters.getTranslations('expression_406')}`,
                          `${error.response.data.message}`,
                          'warning'
                        )
                    }
                });
            }
        },
        getTasksAll(context) {
            api.get(`/tasks/all`).then(response => {
                context.commit("SET_TASKS_DATA", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        addTask(context, payload) {
            api.post(`/tasks`, payload).then(response => {
                this.dispatch('getCalendar', {admin_id: payload.me})
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `${ context.rootGetters.getTranslations('expression_962') }`,
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        updateTask(context, payload) {
            api.put(`/tasks/${payload.id}`, payload).then(response => {
                this.dispatch('getCalendar', {admin_id: payload.me})
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_963'),
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        deleteTask(context, payload) {
            api.delete(`/tasks/${payload.id}`).then(() => {
                // this.dispatch('getTasks', payload.channel_id)
                this.dispatch('getCalendar', {admin_id: payload.me})
                Swal.fire(
                  `${ context.rootGetters.getTranslations('expression_906') }`,
                  `${ context.rootGetters.getTranslations('expression_964') }`,
                  'success'
                )
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        getCalendar(context, payload) {
            api.get(`/tasks/calendar`, {
                params: payload
            }).then(response => {
                context.commit("SET_CALENDAR", response.data);
                this.dispatch('stopLoading');
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                        `${error.response.data.message}`,
                        'warning'
                    )
                }
            });
        },
    },
}
export default tasks;
